import {TelcoStatus, TelcoStatusName} from "../store/features/Team/teamService.ts";

export const getUserStatus = (user: any) => {
    if (user?.doNotDisturbUserStatus?.enabled) {
        return TelcoStatus.DND;
    }
    const telcoStatus = user?.telcoUserStatus?.status;
    if (telcoStatus === TelcoStatus.DND) {
        return TelcoStatus.ONLINE;
    }

    if (telcoStatus === TelcoStatus.OFFLINE) {
        return TelcoStatus.OFFLINE;
    }

    return telcoStatus;
};
export const getUserStatusName = (user: any) => {
    if (user?.doNotDisturbUserStatus?.enabled) {
        return TelcoStatusName.DND;
    }
    const telcoStatus = user?.telcoUserStatus?.status;
    if (telcoStatus === TelcoStatus.DND) {
        return TelcoStatusName.ONLINE;
    }

    if (telcoStatus === TelcoStatus.OFFLINE) {
        return TelcoStatusName.OFFLINE;
    }

    return TelcoStatusName[telcoStatus as TelcoStatus] || TelcoStatusName.ONLINE;
};